/**
 * @author: chenlv
 * @date: 2025/01/22
 * @description: 操作栏组件
 */
import React from 'react';
import classnames from 'classnames';
import ExportTable from '@intelligence/components/ExportTable';
import DimensionSelect from '../DimensionSelect';
import TableSegment from '../TableSegment';
import GenreTableSearch from '../GenreTableSearch';
// import { dbiPageLogMes } from '@intelligence/utils/buriedPointCfg';
import { MAX_ROWS_LIMIT } from '@intelligence/components/DownloadCommon/DownloadPage/utils';

import type { TDimension, TTableSegment } from '../../types';

import './index.scss';

interface IActionBarProps extends IBaseProps {
  entityType: IEntityType;
  downloadLogConfigKey: string;
  /** 品类数据源 */
  genreSource: IGenreSource;
  getDownloadReqParams: () => any;
  /** 当前维度值 */
  dimension: TDimension;
  /** 维度变更回调 */
  onDimensionChange: (value: TDimension) => void;
  /** 当前表格Segment值 */
  tableSegment: TTableSegment;
  /** 表格Segment变更回调 */
  onTableSegmentChange: (value: TTableSegment) => void;
  /** 搜索打点信息 */
  pageLogInfo?: { pageId: string; typeId: string };
  /** 搜索关键字 */
  keyword?: string;
  /** 搜索关键字变更回调 */
  onKeywordChange?: (value: string) => void;
  /** 下载文件名前缀（选中 HotTag 时加上 name_cn/name_en） */
  downloadFileNamePrefix?: string;
}

/**
 * ActionBar 操作栏组件
 * @description 包含搜索框、维度筛选器和表格展示列Segment
 */
const ActionBar: React.FC<IActionBarProps> = (props) => {
  const {
    style,
    className,
    entityType,
    downloadLogConfigKey,
    genreSource,
    getDownloadReqParams,
    dimension,
    onDimensionChange,
    tableSegment,
    onTableSegmentChange,
    pageLogInfo,
    keyword,
    onKeywordChange,
    downloadFileNamePrefix,
  } = props;

  const baseFileName = "Casual Genre Profile";
  const newStyleFileName = downloadFileNamePrefix
    ? `Hot Tags_${downloadFileNamePrefix}_${baseFileName}`
    : baseFileName;

  return (
    <div style={style} className={classnames('dbi-action-bar', className)}>
      <div className="dbi-action-bar__left">
        <DimensionSelect genreSource={genreSource} value={dimension} onChange={onDimensionChange} />
        <TableSegment value={tableSegment} onChange={onTableSegmentChange} />
      </div>
      <div className="dbi-action-bar__right">
        <GenreTableSearch pageLogInfo={pageLogInfo} value={keyword} onChange={onKeywordChange} />
        <ExportTable
          useWebDownload
          downloadModalSize={800}
          entityType={entityType}
          // 'genre-profile' 控制弹窗显示内容
          businessType="casualGenreProfile"
          downloadKey="casualGenreProfile"
          downloadLogConfigKey={downloadLogConfigKey}
          newStyleFileName={newStyleFileName}
          // @ts-ignore
          total={MAX_ROWS_LIMIT}
          isDisableDownload={false}
          // downloadBtnLogConfig={dbiBtnLogMes?.marketProfileCombineDownloadExcel}
          tableParams={getDownloadReqParams()}
        />
      </div>
    </div>
  );
};

export default ActionBar;
